<template>
    <!--
        Select option, manage highlight styles based on mouseenter/mouseleave and keyboard navigation.

        Highlighted: "text-white bg-indigo-600", Not Highlighted: "text-gray-900"
    -->
    <li
        class="cursor-pointer select-none relative py-2 pl-3 pr-9 opacity-80 group-hover:opacity-100"
        :style="{
            color: textColor,
        }"
        @click="select"
    >
        <p class="block truncate font-medium text-base">
            {{ option.label }}
        </p>

        <span v-if="selected" class="absolute inset-y-0 right-0 flex items-center pr-4">
            <CheckIcon class="h-5 w-5" />
        </span>
    </li>
</template>

<script>
import { CheckIcon } from "@easy/ui/icons";

export default {
    components: {
        CheckIcon,
    },
    props: {
        option: {
            type: Object,
            default: () => ({}),
        },
        selected: Boolean,
        highlighted: Boolean,

        textColor: {
            type: String,
            default: "",
        },
    },
    emits: ["select"],
    methods: {
        select() {
            this.$emit("select", this.option.value);
        },
    },
};
</script>
